<template>
  <div class="register-page">
    <!-- Left side: form -->
    <div class="register-left">
      <div class="register-card">
        <h2 class="title">Create an Account</h2>
        <p class="subtitle">Join GAA Africa International</p>

    <form @submit.prevent="register" class="form-register">
          <div class="input-group">
        <input
          type="text"
          v-model="username"
          placeholder="Username"
          :class="{ 'is-invalid': usernameError }"
        />
        <div class="invalid-feedback">{{ usernameError }}</div>
      </div>

          <div class="input-group">
        <input
          type="email"
          v-model="email"
          placeholder="Email"
          :class="{ 'is-invalid': emailError }"
        />
        <div class="invalid-feedback">{{ emailError }}</div>
      </div>

          <div class="input-group">
        <input
          type="password"
          v-model="password"
          placeholder="Password"
          :class="{ 'is-invalid': passwordError }"
        />
        <div class="invalid-feedback">{{ passwordError }}</div>
      </div>

          <button type="submit" class="btn-register" :disabled="loading">
            <span v-if="loading" class="spinner"></span>
        <span v-if="!loading">Register</span>
      </button>

          <div class="separator">OR</div>

          <button @click.prevent="registerWithGoogle" class="btn-google">
            <i class="fab fa-google"></i> Sign up with Google
      </button>

          <div v-if="error" class="error-message">{{ error }}</div>
          <div v-if="success" class="success-message">
            Registration successful! Redirecting...
          </div>
        </form>

        <div class="extra-links">
          <router-link to="/login">Already have an account?</router-link>
        </div>
      </div>
    </div>

    <!-- Background image -->
    <div class="register-bg"></div>
  </div>
</template>

<script>
import { auth, provider } from "@/firebase";
import { createUserWithEmailAndPassword, signInWithPopup, updateProfile } from "firebase/auth";

export default {
  name: "RegisterPage",
  data() {
    return {
      username: "",
      email: "",
      password: "",
      error: "",
      success: false,
      loading: false,
      usernameError: "",
      emailError: "",
      passwordError: "",
    };
  },
  methods: {
    // 🔹 Validation
    validateFields() {
      this.usernameError = this.username ? "" : "Username is required.";

      const emailPattern = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
      this.emailError = this.email
        ? emailPattern.test(this.email)
          ? ""
          : "Please enter a valid email address."
        : "Email is required.";

      this.passwordError = this.password
        ? this.password.length >= 6
          ? ""
          : "Password must be at least 6 characters."
        : "Password is required.";

      return !this.usernameError && !this.emailError && !this.passwordError;
    },

    // 🔹 Register with Email + Password
    async register() {
      if (!this.validateFields()) return;
      this.loading = true;
      this.error = "";

      try {
        // 1️⃣ Create Firebase user
        const userCredential = await createUserWithEmailAndPassword(
          auth,
          this.email,
          this.password
        );
        const user = userCredential.user;

        // 2️⃣ Optionally save display name in Firebase user profile
        await updateProfile(user, {
          displayName: this.username,
        });

        console.log("User registered successfully:", user);
        this.success = true;

        // 3️⃣ Redirect to homepage or login
        setTimeout(() => {
          this.$router.push("/login");
        }, 2000);
      } catch (error) {
        console.error("Registration error:", error);
        this.error = error.message || "Registration failed. Please try again.";
      } finally {
        this.loading = false;
      }
    },

    // 🔹 Register with Google
    async registerWithGoogle() {
      this.loading = true;
      this.error = "";

      try {
        const result = await signInWithPopup(auth, provider);
        const user = result.user;

        console.log("Google user registered:", user);
        this.success = true;

        setTimeout(() => {
          this.$router.push("/");
        }, 2000);
      } catch (error) {
        console.error("Google registration failed:", error);
        this.error = error.message || "Google registration failed.";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>



<style scoped>
.register-page {
  display: flex;
  min-height: 100vh;
  font-family: "Poppins", sans-serif;
}

/* Left: form */
.register-left {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #2c787e;
}

/* Right: background image */
.register-bg {
  width: 50%;
  background-image: url("@/assets/images/login.jpeg"); /* Replace with your image */
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

/* Card */
.register-card {
  background: #fff;
  padding: 40px 30px;
  border-radius: 15px;
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.2);
  width: 380px;
  text-align: center;
}

.title {
  font-size: 28px;
  font-weight: 600;
  margin-bottom: 8px;
  color: #333;
}
.subtitle {
  font-size: 14px;
  margin-bottom: 30px;
  color: #666;
}

/* Inputs */
.input-group {
  margin-bottom: 20px;
}
input {
  width: 100%;
  padding: 12px 15px;
  border-radius: 10px;
  border: 1px solid #ccc;
  outline: none;
  transition: 0.3s;
}
input:focus {
  border-color: #2c787e;
  box-shadow: #2c787e;
}
.is-invalid {
  border-color: #ff4d4f;
}
.invalid-feedback {
  font-size: 12px;
  color: #ff4d4f;
  text-align: left;
  margin-top: 5px;
}

/* Buttons */
.btn-register,
.btn-google {
  width: 100%;
  padding: 12px;
  border-radius: 10px;
  font-weight: 500;
  cursor: pointer;
  border: none;
  transition: 0.3s;
}
.btn-register {
  background: #2c787e;
  color: #fff;
  margin-bottom: 15px;
}
.btn-register:hover {
  background: #40959cff;
}
.btn-google {
  background: #db4437;
  color: #fff;
}
.btn-google:hover {
  background: #c33c2e;
}

/* Spinner */
.spinner {
  border: 2px solid #f3f3f3;
  border-top: 2px solid #fff;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  display: inline-block;
  animation: spin 0.8s linear infinite;
  margin-right: 5px;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Messages */
.error-message {
  margin-top: 15px;
  color: #ff4d4f;
  font-weight: 500;
}
.success-message {
  margin-top: 15px;
  color: #28a745;
  font-weight: 500;
}

/* Extra links */
.extra-links {
  margin-top: 20px;
  font-size: 13px;
}
.extra-links a {
  color: #2c787e;
  text-decoration: none;
}
.extra-links a:hover {
  text-decoration: underline;
}

/* Responsive */
@media (max-width: 992px) {
  .register-page {
    flex-direction: column;
  }
  .register-left,
  .register-bg {
    width: 100%;
  }
}
</style>
